// no baseURI

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	"main": 0,
	"vendor": 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(default\-webpack_sharing_consume_default_(a(ngular_(c(dk_(a11y_angular_cdk_a11y|bidi_angular_cdk_bidi|coercion_angular_cdk_coercion|drag\-drop_angular_cdk_drag\-drop|keycodes_angular_cdk_keycodes|overlay_angular_cdk_overlay|platform_angular_cdk_platform|portal_angular_cdk_portal)|o(mmon_(angular_common|http_angular_common_http)|re_(angular_core|primitives_signals_angular_core_primitiv\-a0f1dc|rxjs\-interop_angular_core_rxjs\-interop)))|platform\-browser_an(gular_platform\-browser|imations_angular_platform\-\-77fea9)|animations_browser_angular_animations_browser|forms_angular_forms)|ws\-amplify_auth_aws\-amplify_auth)|ng(\-zorro\-antd_(core_(co(lor_ng\-zorro\-antd_core_color|nfig_ng\-zorro\-antd_core_config)|animation_ng\-zorro\-antd_core_animation|environments_ng\-zorro\-antd_core_en\-53451e|form_ng\-zorro\-antd_core_form|logger_ng\-zorro\-antd_core_logger|outlet_ng\-zorro\-antd_core_outlet|overlay_ng\-zorro\-antd_core_overlay|polyfill_ng\-zorro\-antd_core_polyfill|transition\-patch_ng\-zorro\-antd_cor\-88efb7|util_ng\-zorro\-antd_core_util|wave_ng\-zorro\-antd_core_wave)|(button_ng\-zorro\-antd_butto|i18n_ng\-zorro\-antd_i18|icon_ng\-zorro\-antd_ico)n|space_ng\-zorro\-antd_space)|rx_store_ngrx_store)|rxjs_(operators_rxjs_operator|rxj)s|lucide\-angular_lucide\-angular)|webpack_(container_remote_(authentica|institu)tion_Routes|sharing_consume_default_(authentication_Routes_authentica|institution_Routes_institu)tion_Routes)|vendor)$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = self["webpackChunkshell"] = self["webpackChunkshell"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));